<template>
  <div class="error">
    <div class="header">
      <div class="icon-error-tip"></div>
      <div class="title">无法打开</div>
      <ul class="error-tip">
        <li class="error-tip-item">1. 尝试网络检查</li>
        <li class="error-tip-item">2. 检查二维码传递参数是否完整</li>
        <li class="error-tip-item">3. 需要传递参数：sn、pcsn、masterSn、opsBrand、sign、osName、opsModel、opsSn、masterModel</li>
      </ul>
    </div>
    <div class="footer">
      <div class="logo"></div>
    </div>
  </div>
</template>

<script>

export default _extend({
  name: 'Error',
  methods: {
  }
});
</script>

<style lang="scss">
@import './Error.scss';
</style>



// WEBPACK FOOTER //
// src/business/views/Error/Error.vue